var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 646,
    viewBox: "0 0 686 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.919 16.3736C340.513 -2.55178 297.478 -3.59925 267.723 7.15946C214.462 26.4044 221.564 69.2972 175.404 99.4784C129.245 129.66 84.8605 119.007 40.4764 158.172C-3.90772 197.337 -7.92004 271.458 10.2952 306.131C28.5104 340.804 49.3532 366.245 31.5996 425.915C13.8459 485.585 15.6213 554.895 86.6359 591.379C157.65 627.863 212.687 550.084 258.846 566.08C305.006 582.076 391.999 652.895 487.868 631.768C583.738 610.641 541.129 537.958 603.267 517.275C665.405 496.592 700.912 425.187 679.608 349.787C658.303 274.387 605.042 259.883 617.47 212.463C626.844 176.654 639.414 142.194 615.517 107.716C584.679 63.2255 531.897 44.1403 480.767 48.6497C461.717 50.4251 439.934 51.011 420.032 46.395C397.414 41.1044 386.957 28.4106 368.919 16.3736Z",
    fill: "url(#paint0_linear_2071_18299)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M368.919 16.3736C340.513 -2.55178 297.478 -3.59925 267.723 7.15946C214.462 26.4044 221.564 69.2972 175.404 99.4784C129.245 129.66 84.8605 119.007 40.4764 158.172C-3.90772 197.337 -7.92004 271.458 10.2952 306.131C28.5104 340.804 49.3532 366.245 31.5996 425.915C13.8459 485.585 15.6213 554.895 86.6359 591.379C157.65 627.863 212.687 550.084 258.846 566.08C305.006 582.076 391.999 652.895 487.868 631.768C583.738 610.641 541.129 537.958 603.267 517.275C665.405 496.592 700.912 425.187 679.608 349.787C658.303 274.387 605.042 259.883 617.47 212.463C626.844 176.654 639.414 142.194 615.517 107.716C584.679 63.2255 531.897 44.1403 480.767 48.6497C461.717 50.4251 439.934 51.011 420.032 46.395C397.414 41.1044 386.957 28.4106 368.919 16.3736Z",
    fill: "#1C2126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.55 280.672L344.987 351.385L344.703 351.19L616.778 215.552C616.991 214.522 617.186 213.492 617.47 212.427C621.82 195.792 626.862 179.441 628.619 163.25L344.863 349.823H344.543L595.704 85.0802C584.63 75.0568 572.003 66.8966 558.315 60.9175L344.224 348.402H343.886L474.003 49.1291C460.216 50.2824 446.349 50.0802 432.601 48.5255L343.141 347.284L342.821 347.444L363.291 12.9471C350.382 6.10974 336.205 2.00043 321.641 0.874649L341.72 346.609L341.49 346.858L244.501 19.4272C230.796 29.6711 223.073 42.507 214.817 55.7512L340.176 346.467L340.034 346.769L162.497 106.899C150.579 112.757 138.084 117.363 125.215 120.641L338.738 346.84V347.195L46.0512 153.521C44.2758 154.994 42.3406 156.521 40.4765 158.154C31.2382 166.403 23.4802 176.173 17.5388 187.039L337.371 347.728L337.477 348.047L0.477539 267.144C1.525 282.288 4.96921 295.905 10.2953 306.113C11.183 307.889 12.0707 309.486 12.9761 311.137L336.465 348.988L336.661 349.272L38.3993 383.253C38.345 396.478 36.4143 409.628 32.6649 422.311L336.11 350.444L336.394 350.639L23.7348 506.534C25.7912 521.184 30.7334 535.28 38.2751 548.007L336.164 352.06H336.483L103.2 597.965C121.824 603.292 139.311 601.516 155.804 596.527L336.803 353.48H337.14L245.638 563.861C250.132 563.858 254.596 564.602 258.846 566.062C263.599 567.753 268.262 569.684 272.819 571.85L337.886 354.598L338.205 354.439L323.31 597.912C333.092 602.901 343.443 607.925 354.255 612.612L339.306 355.273L339.537 355.024L421.949 633.224C435.04 635.328 448.318 636.025 461.558 635.301L340.833 355.38L340.975 355.078L531.72 612.861C543.739 603.522 550.468 592.373 555.457 580.904L342.289 355.042V354.687L593.787 521.145C596.818 519.617 599.957 518.311 603.178 517.24C614.65 513.436 625.439 507.82 635.135 500.604L343.656 354.155L343.549 353.835L680.016 434.596C683.954 421.025 685.897 406.953 685.786 392.822L344.561 352.894L344.366 352.61L666.328 315.931C659.794 303.527 652.171 291.728 643.55 280.672ZM336.27 350.444L337.3 350.195L336.536 350.586L336.27 350.444ZM336.661 351.971H336.341L337.247 351.367L336.661 351.971ZM337.229 353.214H336.945L337.584 352.361L337.229 353.214ZM336.962 349.166L336.767 348.953L337.832 349.077L336.962 349.166ZM338.276 354.137L338.028 354.297L338.329 353.267L338.276 354.137ZM337.761 348.029L337.655 347.763L338.614 348.243L337.761 348.029ZM341.809 346.769V347.834L341.561 347.018L341.809 346.769ZM340.336 346.591L340.762 347.586L340.247 346.893L340.336 346.591ZM338.898 346.947L339.626 347.728L338.915 347.248L338.898 346.947ZM339.359 354.971V353.906L339.608 354.723L339.359 354.971ZM340.833 355.149L340.407 354.155L340.922 354.847L340.833 355.149ZM340.673 352.361H340.158L339.697 352.131L339.341 351.758L339.146 351.278V350.764L339.288 350.266L339.608 349.858L340.034 349.574L340.531 349.45H341.046L341.507 349.681L341.862 350.053L342.058 350.533V351.048L341.916 351.545L341.596 351.953L341.17 352.237L340.673 352.361ZM341.543 354.013L342.253 354.492V354.794L341.543 354.013ZM344.437 349.84H344.756L343.851 350.444L344.437 349.84ZM343.869 348.598H344.153L343.514 349.45L343.869 348.598ZM342.892 347.603L343.141 347.444L342.839 348.456L342.892 347.603ZM342.555 353.498L343.407 353.711L343.514 353.977L342.555 353.498ZM343.336 352.663L344.064 352.717L344.259 352.93L343.336 352.663ZM343.798 351.616L344.561 351.225L344.827 351.367L343.798 351.616Z",
    fill: "#1C2126"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.963 645.865C490.412 645.865 614.807 639.458 614.807 631.555C614.807 623.652 490.412 617.246 336.963 617.246C183.513 617.246 59.1182 623.652 59.1182 631.555C59.1182 639.458 183.513 645.865 336.963 645.865Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.345 377.838H516.541C518.561 377.838 520.498 378.64 521.926 380.069C523.355 381.497 524.157 383.434 524.157 385.454V605.777H165.711V385.454C165.711 384.453 165.909 383.461 166.292 382.536C166.676 381.61 167.239 380.77 167.948 380.062C168.657 379.355 169.499 378.794 170.425 378.413C171.351 378.031 172.343 377.836 173.345 377.838Z",
    fill: "url(#paint1_linear_2071_18299)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.756 395.13H498.131C499.131 395.13 500.121 395.327 501.046 395.71C501.97 396.093 502.809 396.654 503.516 397.361C504.224 398.068 504.785 398.908 505.167 399.832C505.55 400.756 505.747 401.746 505.747 402.746V608.848H184.122V402.764C184.12 401.761 184.316 400.767 184.698 399.84C185.081 398.913 185.643 398.07 186.353 397.361C187.062 396.651 187.905 396.089 188.832 395.706C189.759 395.324 190.753 395.128 191.756 395.13Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M521.086 624.188H152.84C135.885 624.188 122.144 613.926 122.144 601.268H551.782C551.782 613.926 538.041 624.188 521.086 624.188Z",
    fill: "url(#paint2_linear_2071_18299)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.407 167.954C321.46 188.83 265.324 209.921 199.862 254.655C199.862 254.655 203.949 405.812 343.407 488.442V167.954Z",
    fill: "url(#paint3_linear_2071_18299)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M343.407 167.954C365.338 188.83 421.49 209.92 486.952 254.655C486.952 254.655 482.866 405.812 343.407 488.442V167.954Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.787296,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343.407 180.823C316.929 199.589 271.041 217.483 210.391 258.922C210.391 258.922 214.18 398.974 343.407 475.574C472.633 399.007 476.423 258.922 476.423 258.922C415.756 217.5 370.083 199.589 343.407 180.823Z",
    fill: "url(#paint4_linear_2071_18299)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M453.752 244.044C361.219 272.054 290.633 353.366 258.536 396.255C280.614 428.644 309.601 455.734 343.408 475.574C472.634 399.007 476.424 258.922 476.424 258.922C468.614 253.605 461.057 248.646 453.752 244.044Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.792 322.044H294.586C292.401 322.044 290.306 321.176 288.761 319.631C287.216 318.086 286.348 315.991 286.348 313.806V267.111C286.604 251.948 292.807 237.493 303.62 226.861C314.433 216.228 328.991 210.27 344.156 210.27C359.321 210.27 373.879 216.228 384.692 226.861C395.505 237.493 401.709 251.948 401.965 267.111V313.806C401.965 315.979 401.106 318.065 399.575 319.608C398.044 321.151 395.966 322.027 393.792 322.044ZM302.89 305.567H385.554V267.111C385.338 256.292 380.888 245.989 373.161 238.414C365.433 230.839 355.043 226.596 344.222 226.596C333.401 226.596 323.011 230.839 315.283 238.414C307.556 245.989 303.106 256.292 302.89 267.111V305.567Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.787296,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M406.512 299.537H280.301V406.19H406.512V299.537Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.787296,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M356.522 343.826C356.522 341.397 355.878 339.012 354.656 336.913C353.434 334.814 351.678 333.076 349.565 331.877C347.453 330.677 345.061 330.059 342.632 330.086C340.203 330.112 337.825 330.782 335.739 332.026C333.653 333.271 331.934 335.046 330.758 337.171C329.582 339.296 328.99 341.695 329.042 344.124C329.095 346.552 329.79 348.923 331.057 350.995C332.324 353.068 334.118 354.767 336.256 355.92L333.949 380.141H351.612L349.305 355.92C351.49 354.746 353.315 353.001 354.586 350.871C355.856 348.741 356.526 346.306 356.522 343.826Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.787296,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M611.345 335.123L611.132 332.46",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M610.617 327.151C603.587 260.607 572.551 198.904 523.317 153.588C474.082 108.273 410.023 82.4489 343.125 80.9495C276.227 79.4501 211.075 102.378 159.859 145.442C108.644 188.506 74.8746 248.757 64.8701 314.919C64.1126 319.961 63.5208 325.021 63.0947 330.098",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.55 2.55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7755 332.726L62.5625 335.371",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.9 288.857L139.63 224.855H91.9082L123.9 288.857Z",
    fill: "#37474F",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.901 288.857L127.398 227.287H97.0215L123.901 288.857Z",
    fill: "url(#paint5_linear_2071_18299)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.901 288.857L120.652 222.494H90.2754L123.901 288.857Z",
    fill: "url(#paint6_linear_2071_18299)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1959 219.422L59.3666 210.563H18.1426L37.4763 288.857H123.901L110.195 219.422H67.1959Z",
    fill: "#37474F",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.634 98.2536H112.681C109.082 98.2536 106.165 101.171 106.165 104.769V160.391C106.165 163.99 109.082 166.907 112.681 166.907H215.634C219.233 166.907 222.15 163.99 222.15 160.391V104.769C222.15 101.171 219.233 98.2536 215.634 98.2536Z",
    fill: "#37474F",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.15 111.267H106.165V136.122H222.15V111.267Z",
    fill: "url(#paint7_linear_2071_18299)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M197.668 155.935C197.668 154.977 197.384 154.039 196.851 153.242C196.319 152.445 195.562 151.824 194.676 151.457C193.79 151.09 192.816 150.994 191.876 151.182C190.936 151.369 190.072 151.83 189.394 152.508C188.716 153.186 188.255 154.049 188.068 154.99C187.881 155.93 187.977 156.904 188.344 157.79C188.71 158.676 189.332 159.432 190.129 159.965C190.926 160.498 191.863 160.782 192.821 160.782C194.107 160.782 195.34 160.271 196.249 159.362C197.157 158.453 197.668 157.221 197.668 155.935Z",
    fill: "#263238",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M211.142 155.935C211.142 154.977 210.857 154.039 210.325 153.242C209.792 152.445 209.035 151.824 208.15 151.457C207.264 151.09 206.29 150.994 205.349 151.182C204.409 151.369 203.546 151.83 202.868 152.508C202.19 153.186 201.728 154.049 201.541 154.99C201.354 155.93 201.45 156.904 201.817 157.79C202.184 158.676 202.805 159.432 203.602 159.965C204.399 160.498 205.336 160.782 206.295 160.782C207.58 160.782 208.813 160.271 209.722 159.362C210.631 158.453 211.142 157.221 211.142 155.935Z",
    fill: "#263238",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M408.101 52.2539H283.896V132.784H408.101V52.2539Z",
    fill: "url(#paint8_linear_2071_18299)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.474 57.3669H289.951V127.014H402.474V57.3669Z",
    fill: "#37474F",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.866 105.941C322.866 98.3423 316.688 85.2756 309.09 85.2756C301.491 85.2756 295.295 98.3423 295.295 105.941C295.295 113.539 301.473 115.421 309.09 115.421C316.706 115.421 322.866 113.486 322.866 105.941Z",
    fill: "#263238",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M309.089 87.7967C314.325 87.7967 318.569 83.5521 318.569 78.3162C318.569 73.0803 314.325 68.8358 309.089 68.8358C303.853 68.8358 299.608 73.0803 299.608 78.3162C299.608 83.5521 303.853 87.7967 309.089 87.7967Z",
    fill: "#263238",
    stroke: "#37474F",
    strokeWidth: 0.848313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M336.643 70.6289H359.598",
    stroke: "#263238",
    strokeWidth: 1.69663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M336.643 80.5709H359.598",
    stroke: "#263238",
    strokeWidth: 1.69663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M336.643 98.1825H390.205",
    stroke: "#263238",
    strokeWidth: 1.69663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M336.643 111.196H390.205",
    stroke: "#263238",
    strokeWidth: 1.69663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M578.074 98.2536H485.702C479.986 98.2536 475.352 102.888 475.352 108.604V156.681C475.352 162.397 479.986 167.031 485.702 167.031H578.074C583.791 167.031 588.425 162.397 588.425 156.681V108.604C588.425 102.888 583.791 98.2536 578.074 98.2536Z",
    fill: "#37474F",
    stroke: "#37474F",
    strokeWidth: 1.69663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M536.406 130.92L588.425 104.609V103.402C588.425 102.037 587.882 100.727 586.917 99.7616C585.951 98.796 584.641 98.2536 583.276 98.2536H480.518C479.151 98.2536 477.839 98.7955 476.871 99.7605C475.903 100.726 475.356 102.035 475.352 103.402V104.84L526.429 131.045C527.986 131.804 529.7 132.189 531.432 132.167C533.165 132.146 534.868 131.719 536.406 130.92Z",
    fill: "url(#paint9_linear_2071_18299)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M645.433 218.162H545.533C541.562 218.162 538.343 221.381 538.343 225.352V268.653C538.343 272.624 541.562 275.843 545.533 275.843H645.433C649.404 275.843 652.623 272.624 652.623 268.653V225.352C652.623 221.381 649.404 218.162 645.433 218.162Z",
    fill: "#37474F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M538.36 260.753V291.733L555.635 271.849",
    fill: "#37474F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M578.199 248.059C578.203 246.885 577.858 245.736 577.207 244.758C576.557 243.78 575.631 243.017 574.547 242.566C573.463 242.115 572.269 241.996 571.117 242.225C569.965 242.453 568.907 243.018 568.077 243.848C567.246 244.679 566.681 245.737 566.453 246.889C566.225 248.041 566.344 249.234 566.795 250.319C567.246 251.403 568.008 252.329 568.986 252.979C569.964 253.629 571.113 253.974 572.287 253.971C573.854 253.966 575.355 253.342 576.463 252.234C577.57 251.126 578.195 249.625 578.199 248.059Z",
    fill: "url(#paint10_linear_2071_18299)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M603.569 248.059C603.573 246.885 603.228 245.736 602.577 244.758C601.927 243.78 601.001 243.017 599.917 242.566C598.833 242.115 597.639 241.996 596.487 242.225C595.335 242.453 594.277 243.018 593.447 243.848C592.616 244.679 592.051 245.737 591.823 246.889C591.595 248.041 591.714 249.234 592.165 250.319C592.616 251.403 593.379 252.329 594.356 252.979C595.334 253.629 596.483 253.974 597.657 253.971C599.224 253.966 600.725 253.342 601.833 252.234C602.94 251.126 603.565 249.625 603.569 248.059Z",
    fill: "url(#paint11_linear_2071_18299)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M628.957 248.059C628.961 246.885 628.616 245.737 627.966 244.76C627.317 243.782 626.392 243.019 625.309 242.568C624.226 242.116 623.033 241.996 621.881 242.223C620.73 242.45 619.672 243.013 618.841 243.842C618.01 244.67 617.443 245.727 617.213 246.878C616.983 248.028 617.099 249.222 617.547 250.306C617.996 251.391 618.756 252.318 619.731 252.97C620.707 253.623 621.854 253.971 623.027 253.971C624.596 253.966 626.098 253.342 627.209 252.235C628.319 251.128 628.948 249.627 628.957 248.059Z",
    fill: "url(#paint12_linear_2071_18299)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 362.073C123.02 361.71 122.663 361.415 122.253 361.212C121.844 361.009 121.393 360.902 120.936 360.901H44.2405L41.2934 352.024C41.0932 351.434 40.7133 350.922 40.207 350.559C39.7007 350.196 39.0935 350.001 38.4706 350H19.0481C18.2991 350.058 17.5995 350.397 17.0892 350.948C16.5789 351.499 16.2954 352.223 16.2954 352.974C16.2954 353.725 16.5789 354.449 17.0892 355C17.5995 355.551 18.2991 355.89 19.0481 355.948H36.3224L55.0525 412.138C55.2504 412.729 55.6297 413.243 56.1365 413.607C56.6433 413.97 57.2517 414.164 57.8753 414.162H58.9583C57.8916 415.806 57.3243 417.724 57.325 419.683C57.3155 421.282 57.6799 422.861 58.3889 424.294C59.0979 425.727 60.132 426.975 61.4087 427.937C62.6854 428.9 64.1693 429.551 65.7422 429.838C67.315 430.126 68.9333 430.042 70.4678 429.593C72.0024 429.144 73.4108 428.342 74.5807 427.252C75.7507 426.163 76.6498 424.814 77.2063 423.316C77.7628 421.817 77.9614 420.208 77.7862 418.619C77.611 417.03 77.0668 415.504 76.1971 414.162H90.4C89.3333 415.806 88.766 417.724 88.7667 419.683C88.7091 421.066 88.9317 422.445 89.421 423.739C89.9103 425.034 90.6563 426.215 91.614 427.214C92.5717 428.212 93.7215 429.007 94.9941 429.549C96.2667 430.092 97.6359 430.372 99.0194 430.372C100.403 430.372 101.772 430.092 103.045 429.549C104.317 429.007 105.467 428.212 106.425 427.214C107.383 426.215 108.128 425.034 108.618 423.739C109.107 422.445 109.33 421.066 109.272 419.683C109.273 417.724 108.705 415.806 107.639 414.162H109.929C110.339 414.194 110.751 414.14 111.139 414.005C111.527 413.87 111.883 413.656 112.185 413.377C112.487 413.098 112.727 412.759 112.892 412.383C113.057 412.006 113.142 411.599 113.142 411.188C113.142 410.777 113.057 410.371 112.892 409.994C112.727 409.617 112.487 409.279 112.185 408.999C111.883 408.72 111.527 408.506 111.139 408.371C110.751 408.236 110.339 408.183 109.929 408.215H60.0058L56.7213 398.397H112.432C113.087 398.396 113.723 398.18 114.243 397.783C114.762 397.385 115.137 396.827 115.308 396.195L123.795 364.665C123.919 364.224 123.939 363.76 123.852 363.31C123.766 362.86 123.576 362.436 123.298 362.073ZM67.5688 423.98C66.7191 423.98 65.8884 423.728 65.1819 423.256C64.4753 422.784 63.9246 422.113 63.5995 421.328C63.2743 420.542 63.1892 419.679 63.355 418.845C63.5208 418.012 63.93 417.246 64.5308 416.645C65.1317 416.044 65.8972 415.635 66.7306 415.47C67.564 415.304 68.4279 415.389 69.213 415.714C69.998 416.039 70.669 416.59 71.1411 417.296C71.6132 418.003 71.8652 418.834 71.8652 419.683C71.8605 420.821 71.4064 421.911 70.6017 422.716C69.7969 423.521 68.7068 423.975 67.5688 423.98ZM99.117 423.98C98.2673 423.98 97.4366 423.728 96.7301 423.256C96.0236 422.784 95.4729 422.113 95.1477 421.328C94.8225 420.542 94.7374 419.679 94.9032 418.845C95.069 418.012 95.4782 417.246 96.079 416.645C96.6799 416.044 97.4454 415.635 98.2789 415.47C99.1123 415.304 99.9761 415.389 100.761 415.714C101.546 416.039 102.217 416.59 102.689 417.296C103.161 418.003 103.413 418.834 103.413 419.683C103.411 420.251 103.297 420.813 103.077 421.337C102.856 421.861 102.535 422.336 102.131 422.735C101.727 423.134 101.248 423.45 100.722 423.663C100.195 423.877 99.6318 423.984 99.0638 423.98H99.117ZM107.053 392.449H96.0279V366.92H107.053V392.449ZM79.0377 366.92H90.0627V392.503H79.0377V366.92ZM73.0902 392.503H62.0652V366.92H73.0902V392.503ZM46.2289 366.92H56.1V392.503H54.7684L46.2289 366.92ZM113 381.975V366.92H117.048L113 381.975Z",
    fill: "#37474F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M607.084 347.692C598.595 347.689 590.296 350.203 583.237 354.917C576.178 359.63 570.675 366.332 567.425 374.174C564.175 382.015 563.324 390.645 564.979 398.97C566.634 407.295 570.721 414.943 576.724 420.945C582.726 426.947 590.373 431.035 598.699 432.69C607.024 434.345 615.654 433.494 623.495 430.244C631.337 426.994 638.038 421.491 642.752 414.432C647.466 407.372 649.98 399.074 649.976 390.585C649.962 379.214 645.439 368.312 637.398 360.271C629.357 352.23 618.455 347.706 607.084 347.692ZM607.084 353.018C610.634 353.018 614.505 357.67 617.239 365.446H596.929C599.716 357.67 603.48 353.018 607.084 353.018ZM618.783 370.772C620.087 376.382 620.807 382.111 620.931 387.869H593.218C593.342 382.111 594.062 376.382 595.366 370.772H618.783ZM621.02 393.248C620.874 399.956 619.884 406.619 618.073 413.079H596.165C594.39 406.638 593.43 399.999 593.307 393.319L621.02 393.248ZM587.963 387.922H569.623C570.054 381.858 571.956 375.99 575.163 370.825H589.863C588.658 376.448 587.992 382.173 587.874 387.922H587.963ZM587.963 393.248C588.052 399.934 588.904 406.587 590.502 413.079H576.991C572.685 407.339 570.126 400.478 569.623 393.319L587.963 393.248ZM592.171 418.405C593.215 421.315 594.61 424.088 596.325 426.661C590.932 425.032 585.975 422.21 581.82 418.405H592.171ZM597.94 418.405H616.209C613.599 424.619 610.244 428.241 607.084 428.241C603.923 428.241 600.568 424.548 597.94 418.405ZM621.979 418.405H632.329C628.175 422.21 623.218 425.032 617.825 426.661C619.539 424.088 620.934 421.315 621.979 418.405ZM623.648 413.079C625.308 406.595 626.214 399.94 626.346 393.248H644.597C644.087 400.439 641.503 407.327 637.158 413.079H623.648ZM626.346 387.922C626.229 382.173 625.563 376.448 624.358 370.825H639.058C642.265 375.99 644.166 381.858 644.597 387.922H626.346ZM635.046 365.499H622.955C621.81 361.638 620.106 357.965 617.896 354.598C624.477 356.605 630.383 360.375 634.975 365.499H635.046ZM596.396 354.598C594.185 357.963 592.486 361.636 591.354 365.499H579.246C583.837 360.375 589.744 356.605 596.325 354.598H596.396Z",
    fill: "#37474F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2071_18299",
    x1: 173.756,
    y1: -83.3426,
    x2: 781.273,
    y2: 476.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2071_18299",
    x1: 256.483,
    y1: 347.832,
    x2: 466.03,
    y2: 629.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2071_18299",
    x1: 230.944,
    y1: 598.25,
    x2: 233.682,
    y2: 642.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2071_18299",
    x1: 236.213,
    y1: 125.765,
    x2: 441.312,
    y2: 204.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2071_18299",
    x1: 277.76,
    y1: 142.021,
    x2: 551.178,
    y2: 352.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2071_18299",
    x1: 104.714,
    y1: 219.182,
    x2: 146.967,
    y2: 236.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2071_18299",
    x1: 98.7906,
    y1: 213.757,
    x2: 145.18,
    y2: 233.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2071_18299",
    x1: 135.537,
    y1: 107.995,
    x2: 146.801,
    y2: 152.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2071_18299",
    x1: 315.35,
    y1: 41.6527,
    x2: 389.782,
    y2: 139.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2071_18299",
    x1: 503.986,
    y1: 93.789,
    x2: 524.341,
    y2: 151.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2071_18299",
    x1: 569.343,
    y1: 240.55,
    x2: 580.58,
    y2: 250.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2071_18299",
    x1: 594.713,
    y1: 240.55,
    x2: 605.95,
    y2: 250.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2071_18299",
    x1: 620.101,
    y1: 240.55,
    x2: 631.337,
    y2: 250.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/Image 3.977b9f945d5c68ad3e427051850d3edc.svg";
export { ForwardRef as ReactComponent };